import React, { Fragment, PureComponent } from 'react';
// redux
import { updateUser } from '../../../redux/reducers/auth';
import { connect } from 'react-redux';
// components
import Icon from '../../../components/Icon/Icon';
import TextArea from '../../../components/TextArea/TextArea';
// utils
import classnames from 'classnames/bind';
import { toastResponseErrors } from '../../../utils/response';
// prop-types
import T from 'prop-types';
// styles
import styles from '../RecoveryPlan.mod.css';

const cx = classnames.bind(styles);

class Statement extends PureComponent {
  state = {
    isEditStatement: false,
    personalStatement: '',
  };

  updatePersonalStatement = () => {
    const { updateUser, id } = this.props;
    const { personalStatement } = this.state;
    const str = personalStatement.trim().length ? personalStatement : '';
    updateUser({
      id,
      data: {
        statement: str,
      },
    })
      .then(() =>
        this.setState({ isEditStatement: false, personalStatement: '' })
      )
      .catch(toastResponseErrors);
  };

  addPersonalStatement = () => this.setState({ isEditStatement: true });

  handleChangePersonalStatement = event => {
    this.setState({ personalStatement: event.target.value });
  };

  handlerKeyPress = event => {
    if (
      !event.shiftKey &&
      (event.which === 13 || event.keyCode === 13 || event.key === 'Enter')
    ) {
      event.preventDefault();
      this.updatePersonalStatement();
    }
  };

  buttonStatementAdd = () => (
    <button
      className={cx('add-item')}
      onClick={this.addPersonalStatement}
      style={{ color: this.props.userColor }}
    >
      <Icon
        type="add"
        className={cx('add-item-icon')}
        style={{ backgroundColor: this.props.userColor }}
      />
      Add personal statement
    </button>
  );

  textAreaStatement = () => (
    <div>
      <TextArea
        color={this.props.userColor}
        className={styles.textArea}
        name="personal_statement"
        rows="3"
        placeholder="Type a personal statement"
        value={this.state.personalStatement}
        onChange={this.handleChangePersonalStatement}
        onKeyPress={this.handlerKeyPress}
      />
    </div>
  );

  textStatement = () => (
    <p
      className={cx('blockquote')}
      style={{ borderColor: this.props.userColor }}
    >
      {this.props.statement}
    </p>
  );

  render() {
    const { isEditStatement } = this.state;
    const { statement } = this.props;

    const Component = statement
      ? this.textStatement
      : isEditStatement
      ? this.textAreaStatement
      : this.buttonStatementAdd;

    return (
      <Fragment>
        <Component />
      </Fragment>
    );
  }
}

Statement.propTypes = {
  updateUser: T.func,
  statement: T.string,
  userColor: T.string,
  id: T.number,
};

export default connect(
  null,
  { updateUser }
)(Statement);



// WEBPACK FOOTER //
// ./src/containers/RecoveryPlan/components/Statement.jsx